import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["star", "input"]
  static values = { rating: { type: Number, default: 0 } }

  static classes = ["active", "inactive"]

  connect() {
    this.syncStars()
  }

  select(event) {
    event.preventDefault()

    const value = Number.parseInt(event.currentTarget.dataset.value, 10)
    if (Number.isNaN(value)) return

    this.ratingValue = value
    this.inputTarget.value = value
    this.syncStars()
  }

  highlight(event) {
    const value = Number.parseInt(event.currentTarget.dataset.value, 10)
    if (Number.isNaN(value)) return

    this.paintStars(value)
  }

  resetHighlight() {
    this.syncStars()
  }

  syncStars() {
    this.paintStars(this.ratingValue)
  }

  paintStars(value) {
    this.starTargets.forEach((button) => {
      const starValue = Number.parseInt(button.dataset.value, 10)
      const active = starValue <= value

      button.classList.toggle(this.activeClass, active)
      button.classList.toggle(this.inactiveClass, !active)
    })
  }
}
